import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { Tab, TabProps, usePermissions } from 'react-admin'
import { IPermissions } from '../../types/apiTypes'
import { FC } from 'react'

export const RestrictedTab: FC<RestrictedTabProps> = ({
  access,
  children,
  path,
  ...rest
}) => {
  const { permissions } = usePermissions() as IPermissions

  if (permissions !== undefined && access.some((i: string) => permissions?.scopes.includes(i))) {
    return (
      <Root
        path={path}
        className={classes.root}
        {...rest}
      >
        {children}
      </Root>
    )
  }

  return null
}

interface RestrictedTabProps extends TabProps {
  access: string[];
  path?: string;
}

const PREFIX = 'xxllncRestrictedTab'

const classes = {
  root: `${PREFIX}-root`,
}

const Root = styled(Tab)(() => ({
  [`&.${classes.root}`]: {},
}))
